import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const CONSENT_KEY = "okaia-cookie-consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
  }, []);

  const decide = (choice) => () => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ choice, date: new Date().toISOString() }));
    setVisible(false);
    // NOTE : aucun traceur non nécessaire n'est activé sur ce site.
    // Si des outils de mesure d'audience sont ajoutés plus tard,
    // ne les charger ici que si choice === "accepted".
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Gestion des cookies"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-[60] border-t border-[#C8A97E]/40 bg-[#0B2215]"
        >
          <div className="mx-auto flex max-w-[1400px] flex-col gap-5 px-6 py-6 md:flex-row md:items-center md:justify-between md:px-12">
            <div className="max-w-2xl">
              <p className="font-serif-display text-base text-[#F9F8F6]">Respect de votre vie privée</p>
              <p className="mt-2 text-xs font-light leading-relaxed text-[#A3B1AA]">
                Ce site n'utilise aucun cookie publicitaire ni traceur non nécessaire. Seuls des
                cookies strictement indispensables au fonctionnement peuvent être déposés. Pour en
                savoir plus, consultez notre{" "}
                <Link
                  to="/confidentialite"
                  data-testid="cookie-banner-privacy-link"
                  className="underline decoration-[#C8A97E] underline-offset-2 transition-colors duration-300 hover:text-[#C8A97E]"
                >
                  politique de confidentialité
                </Link>
                .
              </p>
            </div>
            <div className="flex flex-shrink-0 flex-col gap-3 sm:flex-row">
              <button
                onClick={decide("refused")}
                data-testid="cookie-refuse-btn"
                className="border border-[#C8A97E]/50 px-6 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#F9F8F6] transition-colors duration-300 hover:border-[#C8A97E] hover:text-[#C8A97E]"
              >
                Continuer sans accepter
              </button>
              <button
                onClick={decide("accepted")}
                data-testid="cookie-accept-btn"
                className="border border-[#C8A97E] bg-[#C8A97E] px-6 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#0B2215] transition-colors duration-300 hover:bg-transparent hover:text-[#C8A97E]"
              >
                Accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
